import { appendHoneyGuide } from "../../../lib/utils";

export const metaDescription =
  'Get upto USD 10 Credits with each ticket. 24x7 hours support from people who know the mountains. 72 hours Free Cancellation.';

export const sectors = [
  { value: 'KTM', title: 'KATHMANDU' },
  { value: 'LUA', title: 'LUKLA' },
  { value: 'RHP', title: 'RAMECHHAP' },
  { value: 'PKR', title: 'POKHARA' },
  { value: 'JMO', title: 'JOMSOM' },
];

const appendBookOnline = (str) => `${str} | Book Online`;

export const appendStatic = str => appendHoneyGuide(appendBookOnline(str));

export const subTitle = 'Change Bookings with 24/7 WhatsApp Support.';



// WEBPACK FOOTER //
// ./src/screens/Flights/static-db/common.js